import { getSummaryCategory } from './service_tickets';

export const requestValue = (request, fieldId) => request?.[fieldId]?.value ?? '';

const calendarDay = value => {
  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  const date = match
    ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
    : new Date(value);
  if (Number.isNaN(date.getTime())) return Number.NaN;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
};

const moveCalendarDays = (timestamp, days) => {
  const date = new Date(timestamp);
  date.setDate(date.getDate() + days);
  return date.getTime();
};

export const isInHomepageDateWindow = (request, now = Date.now()) => {
  const followUpDay = calendarDay(requestValue(request, 32));
  const today = calendarDay(now);
  if (Number.isNaN(followUpDay) || Number.isNaN(today)) return false;
  return followUpDay >= moveCalendarDays(today, -30) && followUpDay <= moveCalendarDays(today, 30);
};

export const getHomepageRequestCategory = (request, now = Date.now()) => {
  const category = getSummaryCategory(request, now);
  if (category === 'dispatched') return 'dispatched';
  if (category === 'complete') return 'complete';
  if (requestValue(request, 31)) return 'scheduled';
  return category === 'pending' ? 'pending' : 'scheduling';
};

export const HOMEPAGE_REQUEST_STATUS = {
  pending: { label: 'Received', color: '#667085' },
  scheduling: { label: 'Scheduling in Progress', color: '#c78122' },
  scheduled: { label: 'Scheduled – Waiting for Service', color: '#8064a9' },
  dispatched: { label: 'Dispatched', color: '#167c80' },
  complete: { label: 'Service Complete', color: '#238153' }
};

export const formatRequestDate = value => {
  if (!value) return '—';
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  const date = match
    ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12)
    : new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};
